import { render, staticRenderFns } from "./QuizSessionHistoryModal.vue?vue&type=template&id=2c7cc4cb&scoped=true"
import script from "./QuizSessionHistoryModal.vue?vue&type=script&lang=js"
export * from "./QuizSessionHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./QuizSessionHistoryModal.vue?vue&type=style&index=0&id=2c7cc4cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7cc4cb",
  null
  
)

export default component.exports